<open-flow-banner [componentDetails]="componentDetails" [formData]="formData"></open-flow-banner>